import { UPDATE_AGENT_LOG } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';
import { AgentLog } from './getAgentLogs';

interface UpdateAgentWorkLogResponse {
  success: boolean;
  message?: string;
  log?: AgentLog;
}

type UpdateAgentWorklogPayload = Pick<
  AgentLog,
  'startTime' | 'stopTime' | 'duration' | '_id'
>;

const updateAgentWorklogApi = async (
  payload: UpdateAgentWorklogPayload & { timeZone?: string }
): Promise<UpdateAgentWorkLogResponse> => {
  try {
    const response = await makeAuthenticatedRequest(UPDATE_AGENT_LOG, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      if (result.message) {
        throw new Error(result.message);
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    return result;
  } catch (error) {
    console.error('Update agent worklog failed:', error);
    throw error;
  }
};

export {
  updateAgentWorklogApi,
  type UpdateAgentWorkLogResponse,
  type UpdateAgentWorklogPayload,
};
